import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminAnalytics.css";

function AdminAnalytics() {
  const navigate = useNavigate();

  return (
    <div className="main-layout">

      <div className="sidebar">
        <h2 className="logo">🏠 RealEstate</h2>

        <ul>
          <li onClick={() => navigate("/admin/dashboard")}>Dashboard</li>
          <li onClick={() => navigate("/admin/properties")}>Properties</li>
          <li onClick={() => navigate("/admin/Buys")}>Buy</li>
          <li className="active">Sales</li>
          <li onClick={() => navigate("/admin/Rents")}>Rent</li>
          <li onClick={() => navigate("/admin/messages")}>Messages</li>
          <li onClick={() => navigate("/admin/settings")}>Settings</li>
        </ul>
      </div>

      <div className="dashboard-container">
        <div className="topbar">📊 Analytics</div>

        <h2>Analytics Page</h2>
      </div>

    </div>
  );
}

export default AdminAnalytics;